export default {
  totalItems: 0,
  totalHold: 0,
  totalApproved: 0
}
